import React from 'react';
import { Table, Input, Checkbox, Empty, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { VendorQualRow } from '../../../services/pw150hApi';

interface ResultTableProps {
  data: VendorQualRow[];
  loading: boolean;
  queried: boolean;
  noData: boolean;
  approving: boolean;
  onToggleApproved: (index: number, checked: boolean) => void;
  onNoteChange: (index: number, note: string) => void;
  onSave: () => void;
}

const ResultTable: React.FC<ResultTableProps> = ({
  data, loading, queried, noData, approving,
  onToggleApproved, onNoteChange, onSave,
}) => {
  const columns: ColumnsType<VendorQualRow> = [
    {
      title: '核准', dataIndex: 'approved', key: 'approved', width: 60, align: 'center' as const,
      render: (_: boolean, __: VendorQualRow, index: number) => (
        <Checkbox checked={data[index]?.approved} onChange={(e) => onToggleApproved(index, e.target.checked)} />
      ),
    },
    { title: '評鑑代號', dataIndex: 'doc_no', key: 'doc_no', width: 160 },
    { title: '廠商類別', dataIndex: 'vendor_type', key: 'vendor_type', width: 80 },
    { title: '核准歷程', dataIndex: 'dept_approval', key: 'dept_approval', ellipsis: true },
    {
      title: '部門核准說明', dataIndex: 'dept_note', key: 'dept_note', width: 250,
      render: (_: string, __: VendorQualRow, index: number) => (
        <Input
          value={data[index]?.dept_note || ''}
          onChange={(e) => onNoteChange(index, e.target.value)}
          placeholder="請填寫核准說明"
          size="small"
        />
      ),
    },
  ];

  if (!queried) return null;
  if (noData) return <Empty description="無須核准資料" style={{ marginTop: 40 }} />;

  const hasSelected = data.some(d => d.approved);

  return (
    <>
      <div style={{ marginBottom: 8, textAlign: 'right' }}>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={onSave}
          loading={approving}
          disabled={!hasSelected}
        >
          存檔
        </Button>
      </div>
      <Table<VendorQualRow>
        columns={columns}
        dataSource={data}
        rowKey="doc_no"
        loading={loading}
        size="small"
        pagination={{ pageSize: 50, showSizeChanger: true, showTotal: (t) => `共 ${t} 筆` }}
        scroll={{ x: 800 }}
      />
    </>
  );
};

export default ResultTable;
